module.exports = __webpack_public_path__ + "static/media/user-lock.c58707be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/backgrounds/user-lock.svg
// module id = 502
// module chunks = 0